/* eslint-disable */

import request from '@/utils/request'

export function getMarketSegmentGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group',
    method: 'get',
    params: query
  })
}

export function addMarketSegmentGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group',
    method: 'post',
    data: query
  })
}

export function updateMarketSegmentGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group',
    method: 'put',
    data: query
  })
}
export function deleteMarketSegmentGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group',
    method: 'delete',
    data: query
  })
}
